import villeJuif from "@/assets/images/salons/salon-villejuif.webp";
import augreyDesCouleurs from "@/assets/images/salons/salon-au-grey-des-couleurs.webp";
import instantGreyHeadSpa from "@/assets/images/salons/salon-head-spa.jpg";
import villeDavray from "@/assets/images/salons/ville-d-avray.webp";
interface OurSalonsImagesData {
  id: string;
  name: string;
  imagePath: string;
  address: string;
  postalCode: string;
  city: string;
}

export const ourSalonsImagesData: OurSalonsImagesData[] = [
  {
    id: "villejuif",
    name: "Salon de Coiffure Villejuif",
    imagePath: villeJuif.src,
    address: "61 Rue Jean Jaurès",
    postalCode: "94800",
    city: "Villejuif",
  },
  {
    id: "au-grey-des-couleurs",
    name: "Au Grey des Couleurs Villejuif",
    imagePath: augreyDesCouleurs.src,
    address: "1 Rue Eugène Varlin",
    postalCode: "94800",
    city: "Villejuif",
  },
  {
    id: "ville-d-avray",
    name: "Salon de Coiffure Ville d'Avray",
    imagePath: villeDavray.src,
    address: "28 Rue de Saint-Cloud",
    postalCode: "92410",
    city: "Ville-d'Avray",
  },
  {
    id: "instant-grey-head-spa",
    name: "Instant Grey Head Spa",
    imagePath: instantGreyHeadSpa.src,
    address: "1 Rue Eugène Varlin",
    postalCode: "94800",
    city: "Villejuif",
  },
];
